module.exports = __webpack_public_path__ + "img/icon／5.7d8f7a8f.png";